import React from 'react';
import * as styles from './Container.module.scss';
/**
 * Primary UI component for user interaction
 */
const Container = ({
  classname,
  children,
  fluid
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname ? classname : ''} ${fluid ? styles.fluid : ''}`
  }, children);
};
export default Container;